import React, {Component} from 'react'
import {Nav, Navbar, NavItem, NavDropdown, MenuItem, Image} from 'react-bootstrap'
import ReactGA from 'react-ga'

import logo from './logo.jpg'

import './index.css'

class Navigation extends Component {
  constructor(props) {
    super(props)

    this.clickNavItem = this.clickNavItem.bind(this)
  }

  clickNavItem(itemName) {
    return (function() {
      ReactGA.event({
        category: 'Navigation',
        action: 'Clicked ' + itemName
      })
    })
  }

  render() {
    return (
      <Navbar fixedTop role='navigation'>
        <Navbar.Header>
          <Navbar.Brand>
            <a href='#'>
              <Image src={logo} responsive/>
            </a>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav pullRight bsStyle='pills'>
            <NavDropdown eventKey={'portfolio'} title='Portfolio' id='basic-nav-dropdown'>
              <MenuItem eventKey={'portfolio3d'}
                        href='#3d'
                        onClick={this.clickNavItem('Portfolio 3D')}>
                3D Reconstructions
              </MenuItem>
              <MenuItem eventKey={'portfolio2d'}
                        href='#2d'
                        onClick={this.clickNavItem('Portfolio 2D')}>
                2D Reconstructions
              </MenuItem>
            </NavDropdown>
            <NavItem eventKey={'contact'}
                     href='#contact'
                     onClick={this.clickNavItem('Contact')}>
              Contact
            </NavItem>
            <NavItem eventKey={'blog'}
                     href='#blog'
                     onClick={this.clickNavItem('Blog Posts')}>
              Blog Posts
            </NavItem>
            <NavItem eventKey={'about'}
                     href='#about'
                     onClick={this.clickNavItem('About')}>
              About
            </NavItem>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    )
  }
}

export default Navigation



// WEBPACK FOOTER //
// ./src/App/Navigation/index.js